import { render, staticRenderFns } from "./VxOrgBreadcrumb.vue?vue&type=template&id=6b1d8134&functional=true&"
import script from "./VxOrgBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./VxOrgBreadcrumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports